import { Node } from 'tiptap';
import { nodeInputRule } from 'tiptap-commands';

export default class NR extends Node {
    get name() {
        return 'New_Ruler'
    }
    get schema() {
        return {
            // group: 'block',
            content: 'inline',
            parseDOM: [{ tag: 'div' },],
            toDOM: () => ['div', 0],
        }
    }

    commands({ type }) {
        // return () => (state, dispatch) => dispatch(state.tr.insertText("hello gooods2"))


    }

    inputRules({ type }) {
        return [
            nodeInputRule(/^(?:\/jimun)$/, type),
        ]
    }
}